import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { IImportModelTagsInfo }from "../../entities/nu-model-info";
import { IFileUpload } from "../../entities/file-upload";

@Component
export default class ImportModelTagsDialog extends Vue {


    @Prop()
    value: IImportModelTagsInfo;

    private userNotifier = new ClientNotifier();
    private busyNotification: string; //Promise<any>;


    filesChange(fileList) {
//        console.log(JSON.stringify(fieldName));
        console.log(JSON.stringify(fileList));

        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fileList[x], fileList[x].name);
            });

        // save it
        this.upload(formData);


//        this.files = event.target.files;
//        var anyFiles = this.$refs.myFiles as any;
 //       this.files = anyFiles.files;

  //                   const formEl = <HTMLFormElement>document.getElementById("uploadModelForm");

   //     const formData = new FormData(formEl);
     //   this.formData = formData;
    }

    upload(formData) {

        this.files = new Array<IFileUpload>();


        const url = "/api/1.0/directory/uploadmodel";

        const request = {
            // url: url,
            //                    type: "POST",
            data: formData,
            //                cache: false,
            //    contentType: false,
            //  processData: false,
            method: "post",
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        return FetchWrapper.fetch(url, request)
            // get data
//            .then(x => x.json())
            .then(x => console.log(x));
    }

    /**
 * Fired after successful upload
 * @param newFile
 * @param oldFile
 */
    inputFile(newFile, oldFile) {
        if (newFile && oldFile/* && newFile.success !== oldFile.success && newFile.success*/) {


            // beforeSend
            this.$emit("tagsUploading");
            if (newFile.active && !oldFile.active)
                this.busyNotification =  this.userNotifier.showBusyNotification(`Uploading ${this.files[0].name}`);

                //if (newFile.response)

                // success                
            if (newFile.success && !oldFile.success) {

                this.files = [];
                this.userNotifier.clear(this.busyNotification);
                if (newFile.response.success) {
                    // Send info back to parent to refresh tree
                    this.$emit("tagsUploaded", this.value);
                }
//                else
                 this.userNotifier.showCommandResponse(newFile.response);


            }

            }
        }

        mounted() {
        this.files = new Array<IFileUpload>();

    }


//    private files: any[];
    private files: Array<IFileUpload>; 
    data() {
//        @Prop({ default: () => [] })

        return {
            files: this.files
    };

    }

    //computed() {
    //    return {




    //        postAction: () => encodeURI(
    //            `/api/1.0/directory/uploadmodel/${this.value.name}/${this.value.description}/${this.value.category}/${
    //            this.value.path}`),
    //}
    //}

    getSelectedFileName() {
        return this.files.length > 0 ? this.files[0].name : "<no file selected>";
    }


    getPostAction() {

        //                    var url = "/api/1.0/nodetags/import/" + objectId;
        //                    url = encodeURI(url);
        //                    $.post({
        //                        url: url,
        //                        data: formData,
        //                        cache: false,
        //                        contentType: false,
        //                        processData: false

        //                    }).done(
        //                        function (data) {
        //                            bootbox.alert(data.response, function () { });
        //                        })
        //                        .always(function () { userNotifier.clear(notification) });

        return encodeURI(
            `/api/1.0/nodetags/import/${this.value.modelId}`);

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/import-model-tags-dialog/import-model-tags-dialog.ts